import * as yup from 'yup';

export const ClientContractsFormSchema = (t: any): yup.AnyObjectSchema =>
  yup.object().shape({
    buyer: yup.string().required(t('clientContracts.validation.buyer.required')),
    materials: yup.array().test({
      message: t('clientContracts.validation.material.required'),
      test: arr => !!arr && arr.length > 0,
    }),
  });
